import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { AppRootState } from "../redux/reducers";

const Results = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const results = location.state?.data;
  const userData: any = useSelector((state: AppRootState) => state.userData);

  useEffect(() => {
    if (!results) {
      navigate('/'); // Redirect to home or another appropriate route
    }
  }, [results, navigate]); // Dependency array includes 'results' and 'navigate'

  // Display the results
  return (
    <div className="w-full lg:w-3/4 min-h-screen bg-gray-100 text-gray-900">
      <h1 className="text-4xl mb-4">{userData.given_name} - Your results are in!</h1>

      <div className="bg-white w-full">
        <img
          className="mx-auto mt-6 w-auto h-72"
          src={results?.current?.result === "notFertile" ? "../../images/JackFinalGif.gif" : "../../images/jack-logo.png"}
          alt="Sample"
        />
        <div className="md:grid md:grid-cols-2 gap-4 p-4 md:p-12 bg-white">
          <div className="mb-4 md:mb-0">
            <h2 className="text-brand-blue-400 text-2xl font-medium mb-3">Patient Information:</h2>
            <ul className="list-disc ml-8 text-lg">
              <li><span className="font-bold">Patient Name: </span>{userData.given_name} {userData.family_name}</li>
              <li><span className="font-bold">Kit ID#: </span>{results?.results?.kitId}</li>
              <li><span className="font-bold">Test Type: </span>Post-Vasectomy Semen Test</li>
              <li><span className="font-bold">Vasectomy Date: </span>{results?.results?.procedureDate}</li>
            </ul>
          </div>
          <div className="mb-4 md:mb-0">
            <h2 className="text-brand-blue-400 text-2xl font-medium mb-3">Sample Information:</h2>
            <ul className="list-disc ml-8 text-lg">
              <li>
                <span className="font-bold">Collection Date: </span>
                {results?.results?.collectionDateTime
                  ? new Date(results.results.collectionDateTime).toLocaleDateString()
                  : 'N/A'}
              </li>
              <li>
                <span className="font-bold">Collection Time: </span>
                {results?.results?.collectionDateTime
                  ? new Date(results.results.collectionDateTime).toLocaleTimeString()
                  : 'N/A'}
              </li>
              <li>
                <span className="font-bold">Lab Testing Date: </span>
                {results?.results?.resultsTimeStamp
                  ? new Date(results.results.resultsTimeStamp * 1000).toLocaleDateString()
                  : 'N/A'}
              </li>
              <li>
                <span className="font-bold">Lab Testing Time: </span>
                {results?.results?.resultsTimeStamp
                  ? new Date(results.results.resultsTimeStamp * 1000).toLocaleTimeString()
                  : 'N/A'}
              </li>
              <li><span className="font-bold">Sample Type: </span>Semen</li>
              <li><span className="font-bold">Sample Source: </span>Ejaculate</li>
            </ul>
          </div>
          <div className="mb-4 md:mb-0">
            <h2 className="text-brand-blue-400 text-2xl font-medium mb-3">Result:</h2>
            <div className="relative flex gap-x-3 mb-2">
              <div className="flex h-6 items-center">
                <input
                  type="checkbox"
                  checked={results?.current?.result === "notFertile"}
                  className="h-7 w-7 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />

              </div>
              <div className="text-sm leading-6">
                <label className="text-lg">No Sperm Detected</label>
              </div>
            </div>
            <div className="relative flex gap-x-3 mb-2">
              <div className="flex h-6 items-center">
                <input
                  type="checkbox"
                  checked={results?.current?.result === "fertile"}
                  className="h-7 w-7 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />
              </div>
              <div className="text-sm leading-6">
                <label className="text-lg">Positive (Sperm Detected) - Patient Follow-up Needed</label>
              </div>
            </div>
            <div className="relative flex gap-x-3 mb-2">
              <div className="flex h-6 items-center">
                <input
                  type="checkbox"
                  checked={results?.current?.result === "questionable"}
                  className="h-7 w-7 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                />

              </div>
              <div className="text-sm leading-6">
                <label className="text-lg">Questionable - See Comments</label>
              </div>
            </div>
          </div>
          <div>
            <h2 className="text-brand-blue-400 text-2xl font-medium mb-3">Comments:</h2>
            <ul className="list-disc ml-8 text-base">
              <li>
                {results?.current?.result === 'notFertile' && 'One well-mixed uncentrifuged post vasectomy semen sample showed azoospermia or only rare non-motile sperm (≤ 100,000 sperm/ml). Based on AUA Vasectomy Guidelines - your vasectomy procedure appears to have been successful.'}
                {results?.current?.result === 'fertile' && 'Sperm concentration (count) could be determined on a counting chamber. If it has been more than 12 weeks since the date of your vasectomy procedure it is recommended that you schedule a follow up with the clinic that performed your vasectomy procedure'}
                {results?.current?.result === 'questionable' && 'One well-mixed uncentrifuged fresh post vasectomy semen shows ≥ 100,000 non-motile sperm/ml. If it has been more than 12 weeks since the date of your vasectomy procedure, it is recommended that you schedule a follow up with the clinic that performed your vasectomy procedure'}
              </li>
            </ul>
          </div>
        </div>
        <span className="text-sm flex p-5">Jack At-Home Semen Test performs qualitative semen analysis as a post-vasectomy test. Samples are examined by certified laboratory personnel in our CLIA lab, using 60 high-power fields (hp~ under 10x eye piece X 40x objective for a total magnification of 400x). Comments are given in order to aid the customer and/or provider in ruling out a failed vasectomy. Comments do not replace laboratory results and caution must be given when correlating subsequent specimens. Patients may be referred elsewhere for qualitative semen analysis if needed.</span>
      </div>
    </div>
  );
};

export default Results;
